import {DEFAULT_CLIENT_NAME} from './constants';

// TODO Temporary solution for handling Cookie header
export class AppState {
  static clientName = DEFAULT_CLIENT_NAME;
  static isExternalDomain = false;
  static planogramName = '';
}
